import Vue from 'vue'
import App from './App.vue'

import router from "./router/index"
import store from "./store/index"
//引入Element UI
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
//全局主题（覆盖 Element UI 默认样式，须在 theme-chalk 之后引入）
import '@/styles/theme.less'
import plugins from "@/utils/plugins";

store.dispatch('initData')

Vue.config.productionTip = false

Vue.use(ElementUI)
Vue.use(plugins)
export const EventBus = new Vue();

//路由守卫
router.beforeEach((to, from, next) => {
    console.log("@@@ router to " + to.name + " from " + from.name)
    if ((to.name === 'test')) {
        document.title = to.meta.title || '测试页面';
        next()
        return
    }

    if ((to.name === 'home')) {
        document.title = to.meta.title || '首页';
        next()
        return
    }

    document.title = to.meta.title || '企业访客管理系统';
    if ((to.name !== 'login') && (!store.state.token || !store.state.accountType)) {
        next({name: 'login'})
    } else {
        next()
    }
})

// console.log = function () {}

new Vue({
    router,
    store,
    render: h => h(App),
}).$mount('#app')
